const DEFAULT_TO_EMAIL = "omar.neto@biolinksolucoes.com.br";

/**
 * Monta o objeto enviado ao EmailJS para o template de contato.
 * Chaves canônicas: from_name, from_email, phone, message (ver EMAILJS_SETUP.md).
 * Aliases cobrem templates no painel que usam outros {{placeholders}}.
 */
export function buildEmailjsContactParams({
  name,
  phone,
  email,
  message,
  toEmail = DEFAULT_TO_EMAIL,
}) {
  return {
    from_name: name,
    from_email: email,
    phone,
    message,
    to_email: toEmail,
    name,
    user_name: name,
    user_email: email,
    email,
    reply_to: email,
    phone_number: phone,
    user_phone: phone,
    tel: phone,
    mensagem: message,
    user_message: message,
  };
}
